import { useEffect } from "react";

/**
 * Renders JSON-LD structured data blocks into <head>.
 * Accepts a single object or an array.
 */
export default function JsonLd({ data }) {
  useEffect(() => {
    const items = Array.isArray(data) ? data : [data];
    const nodes = items.map((d, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-kinflex-jsonld", "1");
      s.textContent = JSON.stringify(d);
      document.head.appendChild(s);
      return s;
    });
    return () => {
      nodes.forEach((n) => { try { document.head.removeChild(n); } catch (_e) { /* ignore */ } });
    };
  }, [JSON.stringify(data)]);
  return null;
}
